const SimulationEvent = require("./SimulationEvent");
const labourTypes = require("../../db/labourType.json");
const labourCosts = require("../../db/labour.json");
const {convert, getCheckedItems, getWageByPref, checkFields, getKeyByOptions} = require("./helper/labour");

class Labour extends SimulationEvent {
  constructor(elements, emit, events) {
    super();
    this.elements = elements;
    this.emit = emit;
    this.events = events;
    this.inputs = {
      capacity: "",
      pref: "",
      options: []
    };
    this.totalCost = 0;
    this.index = null;
    this.init();
  }


  init() {

    super.triggerAll(this.elements);

    super.watch(this.elements.capacityEle, (e) => {
      this.inputs = {
        ...this.inputs,
        capacity: convert(e.target.value)
      }
      if (checkFields(this.inputs)) {
        this.calcTotalCost();
      }
    })


    super.watch(this.elements.prefEle, (e) => {
      const id = parseInt(e.target.value);
      const wage = getWageByPref(id);
      this.inputs = {
        ...this.inputs,
        pref: wage
      }
      if (checkFields(this.inputs)) {
        this.calcTotalCost();
      }
    })


    const checkboxes = this.elements.optionsEle.querySelectorAll(".checkbox");
    for (const checkbox of Array.from(checkboxes)) {
      super.watch(checkbox, (e) => {

        this.inputs = {
          ...this.inputs,
          options: getCheckedItems(checkboxes)
        }

        if (this.inputs.options.length === 0) {
          this.resetTotalCost();
        }

        if (checkFields(this.inputs)) {
          this.calcTotalCost();
        }
      })
    }
  }

  setInputs({prefEle, capacityEle, optionsEle}) {
    this.inputs = {
      capacity: convert(capacityEle),
      pref: getWageByPref(parseInt(prefEle)),
      options: optionsEle
    }


    if (checkFields(this.inputs)) {
      this.calcTotalCost();
    }
  }


  getEmployeeSalary() {
    if ("employee" in labourCosts) {
      const {price} = Array.from(labourCosts.employee)[this.index];
      // console.log(`【人件費】社員：${price}`);
      return price;
    }

    return 0;
  }

  getChefSalary() {
    if ("chef" in labourCosts) {
      let {price} = Array.from(labourCosts.chef)[this.index];
      if (price === null) price = 0;
      // console.log(`【人件費】調理社員：${price}`);
      return price;
    }

    return 0;

  }

  getPartTimerSalary() {

    //提供日数
    const daysToProvide = 25;

    if ("partTimer" in labourCosts) {
      const {number, hour} = labourCosts.partTimer[this.index];
      const sum = number * hour * this.inputs.pref * daysToProvide;
      return sum;
    }

    return 0;
  }

  getWelfareCost() {
    if ("welfare" in labourCosts) {
      const {
        numberOfEmployee,
        numberOfPartTimer,
        // welfare,
        // hygiene,
        // laundry,
        // stoolExamination,
        // checkupEmployee,
        // checkupPartTimer,
        companyHousing
      } = Array.from(labourCosts.welfare)[this.index];
      const employeePrice = labourCosts.employee[this.index].price;
      const chefPrice = labourCosts.chef[this.index].price;
      const welfare = Math.round((employeePrice + chefPrice) * 0.18);
      const hygiene = Math.round((numberOfEmployee + numberOfPartTimer) * 10000 * 2 / 12);
      const laundry = Math.round((numberOfEmployee + numberOfPartTimer) * 500);
      const stoolExamination = Math.round((numberOfEmployee + numberOfPartTimer) * 950);
      const checkupEmployee = Math.round((numberOfEmployee + 1) * 16000 / 12);
      const checkupPartTimer = Math.round((numberOfPartTimer) * 6000 / 12);
      const sum = welfare + hygiene + laundry + stoolExamination + checkupEmployee + checkupPartTimer + companyHousing;
      // console.log(`【人件費】福利厚生　他：${price}`);
      return sum;
    }

    return 0;
  }

  calcTotalCost() {

    if (!this.inputs.capacity || !this.inputs.options.length) return;
    const key = getKeyByOptions(this.inputs.options);
    if ("data" in labourTypes) {
      this.index = labourTypes.data[this.inputs.capacity][key];
      if (isNaN(this.index)) return;
      this.totalCost = this.getEmployeeSalary() + this.getPartTimerSalary() + this.getChefSalary() + this.getWelfareCost();

      this.emit("labour", this.totalCost);
    }
  }

  resetTotalCost() {
    this.totalCost = 0;
    this.emit("labour", this.totalCost);
  }

  getTotalCost() {
    if (!this.totalCost) return 0;
    return this.totalCost;
  }
}


module.exports = Labour;






